import ApiService, { ApiEndpoints } from "utilities/apiService";
import { ContactUsRequest } from "./types";
import { useMutation } from "react-query";

const contactUs = async (request: ContactUsRequest) => {
  return await ApiService.CallApi("POST", ApiEndpoints.ContactUs, request, undefined, undefined, {
    allowAnonymous: true,
  });
};

export const useContactUs = () => {
  return useMutation(contactUs);
};
